import React, {useState} from "react";
import {Form, Button, FormGroup, FormControl, FormLabel, InputGroup} from "react-bootstrap";
import Col from "react-bootstrap/Col";

const EditMemberForm = ({ member, submitEdit }) => {
    const [memberName, setMemberName] = useState(member.name)
    const [isSubmitPending, setIsSubmitPending] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitPending(true);
        await submitEdit(memberName);
        setIsSubmitPending(false);
    }

    return (
        <Form method="patch" onSubmit={handleSubmit}>
            <InputGroup>
                <FormControl name='id' hidden={true} value={member.id} readOnly={true} />
                <Col xs={12}>
                    <FormGroup>
                        <FormLabel>Name</FormLabel>
                        <FormControl
                            type="text"
                            name='name'
                            required={true}
                            value={memberName}
                            onChange={(e) => setMemberName(e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col xs={12} className="mt-3 ms-auto">
                    <Button
                        type='submit'
                        disabled={isSubmitPending}
                    >{isSubmitPending ? "Saving..." : "Submit"}</Button>
                </Col>
            </InputGroup>
        </Form>
    )
};

export default EditMemberForm;
